import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {
    ObservableData,
    // ColumnFilter,
    ApiService, EnvironmentModel,
} from '@cas-hub/acabim-common-client';

import {
    ProjectGroup, ProjectGroupRequest,
    ProjectGroupResponse,
    SiteGroup,
    SiteGroupRequest,
    SiteGroupResponse
} from '../_models/group.model';

@Injectable({
    providedIn: 'root'
})
export class GroupService extends ApiService {

    constructor(protected client: HttpClient,
                protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'site';

    /**
     * Add a new site group
     * @returns A site group object
     */
    public upsertSiteGroup(name: string, id?: string) {
        const body: SiteGroupRequest = {
            GroupName: name
        };
        const endpoint = id ? 'site/group/' + id : 'site/group';
        return this.client.post(this.url(endpoint, true), body, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item as SiteGroup));
    }

    /**
     * Retrieve a paginated array of site groups
     * @returns An array of site groups
     */
    public getSiteGroups(
        first: number,
        length: number,
        sortOrder: number,
        sortField?: string,
        filters?: { objectPropertyName: string, value: string }[]
    ): Observable<ObservableData<SiteGroup>> {

        let params = new HttpParams()
            .set('pageNumber', String((first / length) + 1))
            .set('pageSize', String(length))
            .set('page', (first / length + 1).toString());

        if (sortField) {
            const sortOrderString = sortOrder === 1 ? 'ascending' : 'descending';
            params = params.append('sort', sortField);
            params = params.append('sortDirection', sortOrderString);
        }

        filters?.forEach(filter => params = params.set(filter.objectPropertyName, filter.value));

        return this.client.get(this.url('site/group', true), {
            params,
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(tap(data => console.dir(data)), map(data => ({
            totalRecords: (data as SiteGroupResponse).totalRecords,
            data: (data as SiteGroupResponse).data
        })));
    }

    /**
     * Add a new project group
     * @returns A project group object
     */
    public upsertProjectGroup(name: string, id?: string) {
        console.log('Calling POST project Group');
        const body: ProjectGroupRequest = {
            GroupName: name
        };
        const endpoint = id ? 'project/group/' + id : 'project/group';
        return this.client.post(this.url(endpoint, true), body, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item as ProjectGroup));
    }

    /**
     * Retrieve a paginated array of project groups
     * @returns An array of project groups
     */
    public getProjectGroups(
        first: number,
        length: number,
        sortOrder: number,
        sortField?: string,
        filters?: { objectPropertyName: string, value: string }[]
    ): Observable<ObservableData<ProjectGroup>> {

        let params = new HttpParams()
            .set('pageNumber', String((first / length) + 1))
            .set('pageSize', String(length))
            .set('page', (first / length + 1).toString());

        if (sortField) {
            const sortOrderString = sortOrder === 1 ? 'ascending' : 'descending';
            params = params.append('sort', sortField);
            params = params.append('sortDirection', sortOrderString);
        }

        filters?.forEach(filter => params = params.set(filter.objectPropertyName, filter.value));

        return this.client.get(this.url('project/group', true), {
            params,
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(tap(data => console.log(data)), map(data => ({
            totalRecords: (data as ProjectGroupResponse).totalRecords,
            data: (data as ProjectGroupResponse).data
        })));
    }

}
